import React from 'react';
import { Download } from 'lucide-react';

const DownloadReport = () => (
  <div className="mt-4 text-sm text-gray-600 flex items-center gap-2">
    <Download className="w-4 h-4 text-blue-500" />
    <a
      href={process.env.PUBLIC_URL + "/NASDAQ_PZZA_2023.pdf"}
      download
      className="text-blue-600 hover:underline"
    >
      Download Papa John’s 10-K PDF
    </a>
  </div>
);

export default DownloadReport;
